/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-video-off': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.413 5.069a.625.625 0 00-.625.05l-3.413 2.418V6.525L18.75 2.15l-.9-.9-16.6 16.6.9.9 2.5-2.5h8.475c.69 0 1.25-.56 1.25-1.25v-2.537l3.387 2.418a.625.625 0 00.988-.506v-8.75a.625.625 0 00-.337-.556zm-.913 8.093l-3.387-2.418a.625.625 0 00-.988.506V15H5.9l7.225-7.225v.975a.625.625 0 00.988.506L17.5 6.838v6.324zM2.5 15V5h10V3.75h-10c-.69 0-1.25.56-1.25 1.25v10H2.5z"/>'
  }
})
